module.exports = __webpack_public_path__ + "static/media/dashboard.c6425961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/dashboard.svg
// module id = 962
// module chunks = 0